import get from 'lodash/fp/get';
import set from 'lodash/fp/set';
import { createSelector } from 'reselect';
import { compile } from 'path-to-regexp';
import getActivePagination from 'selectors/getActivePagination';
import { getContentArchiveItems } from 'selectors/getContentArchive';
import getPathMap from 'selectors/getPathMap';
import getMatch from 'selectors/getMatch';

const getLandingPageItem = createSelector(
  [
    get('landingPage'),
    get('contentItem.landing-page.byId'),
  ],
  (landingPageId, landingPagesById) => (landingPagesById ?
    landingPagesById[landingPageId] : null
  ),
);

/**
 * Selector that will return a landing page entity
 *
 * @param {string} type landing page type
 * @return {function}   selector function
 */
const getLandingPage = createSelector(
  [
    getLandingPageItem,
    getActivePagination,
    getPathMap,
    getContentArchiveItems,
    getMatch,
  ],
  (landingPage, pagination, pathMap, relatedItems, { pathType, params }) => {
    if (!landingPage) {
      return null;
    }
    const landingPageToPath = compile(pathMap[pathType]);
    const { totalPages, currentPage } = pagination;

    return {
      relatedItems,
      item: set(
        'path',
        landingPageToPath({ ...params }),
        landingPage,
      ),
      pagination: set(
        'hasMore',
        totalPages ? (1 < totalPages && currentPage < totalPages) : false,
        pagination,
      ),
    };
  },
);

export default getLandingPage;
